import { COLOR4, COLOR2, FONT_BOLD_16_18, RADIO_COLOR } from '../../../constants';

export const GenerateQRStyles = {
  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  labelStyleNew: {
    marginBottom: '0px !important',
  },

  labelStyle: {
    font: 'normal 700 14px/18px Arial',
    color: '#444444',
  },

  keyValue: {
    font: 'normal 700 14px/18px Arial',
    color: '#444444',
  },

  keyInfo: {
    font: 'normal 700 14px/18px Arial',
    color: '#661C69',
    marginLeft: '10px',
  },

  subHead: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '30px',
    color: '#000000',
    marginBottom: '30px',
  },

  headingNew: {
    font: 'normal 700 28px/40px Arial',
    borderBottom: '1px solid #C5CEE0',
  },

  disabledBtn: {
    '&.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '25px',
      color: 'rgba(143, 155, 179, 0.5)',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
    },
  },

  continue_button: {
    border: `1px solid ${RADIO_COLOR}`,
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    borderRadius: '56px',
    opacity: 1,
    width: '246px',
    height: '48px',
    textAlign: 'center',
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    letterSpacing: '1.01px',
    color: COLOR4,
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: `2px`,
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
    '&.Mui-disabled': {
      background: `#E4E9F2`,
      border: `#E4E9F2`,
      borderRadius: '25px',
      color: 'rgba(143, 155, 179, 0.5)',
      font: 'normal normal bold 16px/18px Arial',
      letterSpacing: '1.01px',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#E4E9F2',
      },
    },
  },

  continue_buttonInfo: {
    border: `1px solid ${RADIO_COLOR}`,
    background: `${RADIO_COLOR} 0% 0% no-repeat padding-box`,
    borderRadius: '56px',
    opacity: 1,
    width: '100%',
    height: '48px',
    font: FONT_BOLD_16_18,
    textTransform: 'none',
    letterSpacing: '1.01px',
    color: COLOR4,
    '&:hover': {
      backgroundColor: RADIO_COLOR,
    },
    '&.Mui-disabled span': {
      opacity: 0.6,
    },
  },

  topContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '50px',
    marginBottom: '50px',
    '@media (max-width:600px)': {
      marginTop: '30px',
      marginBottom: '30px',
    },
  },

  infoMainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '83px',
    marginBottom: '83px',
    '@media (max-width:600px)': {
      marginTop: '50px',
      marginBottom: '50px',
    },
  },

  infoContainer: {
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
    borderRadius: '6px',
    width: '456px',
    height: 'auto',
    margin: '0px 30px',
    '@media (max-width:600px)': {
      marginTop: '20px',
      marginBottom: '20px',
    },
  },

  subContainer: {
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
    borderRadius: '6px',
    maxWidth: '869px',
    height: 'auto',
    margin: '0px 30px',
    '@media (max-width:600px)': {
      margin: '0px 20px',
    },
  },
};
